<template>
  <div class="card-detail">
    <div>
      <a-page-header class="page-header" @back="back">
        <div slot="title" style="cursor: pointer" @click="back">
          返回 班级管理/
          <span style="color: #297ede">{{ cardObj.title }}</span>
        </div>
      </a-page-header>
      <a-divider style="margin: 0" />
    </div>
    <div style="padding: 0 40px">
      <div style="margin: 15px 0">
        <div class="title-1" style="margin-bottom: 20px">{{ cardObj.title }}</div>
        <a-button
          v-if="
            cardObj?.wordFile || cardObj?.file?.includes('.doc') || cardObj?.file?.includes('.docx')
          "
          type="primary"
          icon="download"
          style="margin-right: 15px"
          @click="downloadWord(cardObj.wordFile || cardObj.file)"
        >
          下载主题Word文档
        </a-button>
        <a-button
          v-if="
            cardObj?.pptFile || cardObj?.file?.includes('.ppt') || cardObj?.file?.includes('.pptx')
          "
          type="primary"
          icon="download"
          @click="downloadWord(cardObj.pptFile || cardObj.file)"
        >
          下载PPT文档
        </a-button>
      </div>
      <a-divider />
      <div>
        <!--<WordParser :fileUrl="cardObj.fileUrl" />-->
        <div v-html="cardObj.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import WordParser from '@/components/WordParser'
import { downloadFile } from '@/utils/util'

export default {
  name: 'TabCardDetail',
  components: {
    WordParser,
  },
  data() {
    return {
      cardObj: {},
    }
  },
  created() {
    this.cardObj = this.$router.history.current.query
    // console.log('卡片详情页面信息：', this.$router.history.current.query)
  },
  methods: {
    back() {
      this.cardObj?.pagePath
        ? this.$router.push({
            path: this.cardObj.pagePath,
            query: {
              activeKey: this.cardObj.activeKey,
            },
          })
        : this.$router.go(-1)
    },
    downloadWord(file) {
      downloadFile(file, this.cardObj.title)
    },
  },
}
</script>
<style scoped lang="less">
.card-detail {
  min-height: 80vh;
  background-color: #fff;
  border-radius: 10px;
}
.page-header {
  padding: 10px 20px;
  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
}
</style>
